import { PageId } from 'constants/pages'
import { IResponseResult } from 'models/api.model'
import { TAnswer, TQuizAnswer } from 'models/common.model'
import { subscriptionsApi } from 'nove8/api'
import { GlobalError, ProcessingKey } from 'nove8/constants/root-constants'
import { eventLogger } from 'services/eventLogger.service'
import { useZustandSessionStore } from 'zustandGlobalSessionStore'
import { useZustandStore } from 'zustandGlobalStore'

export const saveUserAnswer = async ({
  question,
  answers,
  pageNumber,
  pageName,
  quiz,
  answersToStore,
  isInvoxia,
  invoxiaProductName,
  customProperties,
  commandsLevel,
}: {
  question: string
  answers: TAnswer
  pageNumber: number
  pageName: PageId
  quiz?: TQuizAnswer
  answersToStore?: TAnswer
  isInvoxia?: boolean
  invoxiaProductName?: string
  customProperties?: Record<string, any>
  commandsLevel?: string
}): Promise<void> => {
  const leadId = useZustandStore.getState().lead?.id || ''

  useZustandStore.getState().startProcessing(ProcessingKey.SAVE_USER_ANSWER)

  let response: IResponseResult<unknown>

  if (quiz) {
    isInvoxia
      ? eventLogger.logUpsellComplete({
          pageNumber,
          productName: invoxiaProductName ?? 'minitailz_dog_tracker',
        })
      : eventLogger.logQuestion({
          question: question || pageName,
          answers,
          pageNumber,
          customProperties,
          commandsLevel,
        })

    useZustandSessionStore.setState((state) => ({
      userAnswers: { ...state.userAnswers, ...quiz },
    }))

    // await should not block statistics sending
    response = await subscriptionsApi.updateQuiz(leadId, quiz)
  } else {
    eventLogger.logQuestion({
      question: question || pageName,
      answers,
      pageNumber,
      customProperties,
      commandsLevel,
    })

    useZustandSessionStore.setState((state) => ({
      userAnswers: { ...state.userAnswers, [pageName]: answers },
    }))

    // await should not block statistics sending
    response = await subscriptionsApi.updateQuiz(leadId, {
      [pageName]: answersToStore || answers,
    })
  }

  if (!response.success) {
    useZustandStore.setState({ globalError: GlobalError.COMMON_ERROR })
  }

  useZustandStore.getState().stopProcessing(ProcessingKey.SAVE_USER_ANSWER)
}
